export default __webpack_public_path__ + "static/media/date.c3983c9b.svg";